import ComposeViewState from '../store/schema/ComposeViewState';
import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
import { action } from 'satcheljs/lib/legacy';

export default action('showCcWell')(function showCcWell(viewState: ComposeViewState) {
    if (!viewState.ccRecipientWell) {
        viewState.ccRecipientWell = createRecipientWell(viewState.findPeopleFeedbackManager, []);
    }
});
